<template>
    <fragment v-if="!loading">
        <div class="flex flex-col ">
            <div class="py-2 -my-2 ">
                <!-- mx-10  -->
                <div
                    class="inline-block w-full align-middle shadow sm:rounded-lg"
                >
                    <table class="w-full border-t border-gray-200 table-fixed ">
                        <thead>
                            <tr>
                                <th
                                    class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50"
                                >
                                    Entreprise
                                </th>
                                <th
                                    class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50"
                                >
                                    Contact
                                </th>

                                <th
                                    class="px-6 py-3 border-b border-gray-200 bg-gray-50"
                                ></th>
                            </tr>
                        </thead>
                        <tbody
                            class="bg-white"
                            v-for="(bpi, index) in currentBpis"
                            :key="index"
                        >
                            <tr>
                                <td class="px-6 py-4 border-b border-gray-200">
                                    <div class="flex items-center">
                                        <div class="ml-4">
                                            <div
                                                class="text-sm font-medium leading-5 text-gray-900"
                                            >
                                                <!--                              {{ bpi.forms.user.name }}-->
                                            </div>
                                            <div
                                                class="text-sm leading-5 text-gray-500"
                                            >
                                                {{
                                                    bpi.forms
                                                        .entreprise_info !==
                                                    undefined
                                                        ? bpi.forms
                                                              .entreprise_info
                                                              .name
                                                        : "null"
                                                }}
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td class="px-6 py-4 border-b border-gray-200">
                                    <div
                                        class="text-sm leading-5 text-gray-900"
                                    >
                                        {{
                                            bpi.forms.user.name +
                                                " / " +
                                                bpi.forms.user.cin
                                        }}
                                    </div>
                                    <div
                                        class="text-sm leading-5 text-gray-500"
                                    >
                                        {{
                                            bpi.forms.user.phoneNumber !==
                                            undefined
                                                ? bpi.forms.user.phoneNumber
                                                : " "
                                        }}
                                    </div>
                                </td>

                                <td
                                    class="px-6 py-4 text-sm font-medium leading-5 text-right border-b border-gray-200"
                                >
                                    <span
                                        href="#"
                                        class="flex justify-around text-blue-600 focus:outline-none focus:underline"
                                    >
                                        <svg
                                            @click="selectBpiEdited(bpi)"
                                            viewBox="0 0 20 20"
                                            fill="currentColor"
                                            class="w-6 h-6 cursor-pointer pencil-alt hover:text-blue-900"
                                        >
                                            <path
                                                d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z"
                                            ></path>
                                            <path
                                                fill-rule="evenodd"
                                                d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z"
                                                clip-rule="evenodd"
                                            ></path>
                                        </svg>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div
                        class="flex items-center justify-between w-full px-4 py-3 bg-white border-t border-gray-200 sm:px-6"
                    >
                        <div class="flex justify-between flex-1 sm:hidden">
                            <a
                                href="#"
                                class="relative inline-flex items-center px-4 py-2 text-sm font-medium leading-5 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-md hover:text-gray-500 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 active:bg-gray-100 active:text-gray-700"
                            >
                                Previous
                            </a>
                            <a
                                href="#"
                                class="relative inline-flex items-center px-4 py-2 ml-3 text-sm font-medium leading-5 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-md hover:text-gray-500 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 active:bg-gray-100 active:text-gray-700"
                            >
                                Next
                            </a>
                        </div>
                        <div
                            class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between"
                        >
                            <div></div>
                            <div>
                                <nav class="relative z-0 inline-flex shadow-sm">
                                    <button
                                        :disabled="isPrevPageDisabled"
                                        v-if="page !== 1"
                                        @click="prevBpi"
                                        class="relative inline-flex items-center px-2 py-2 text-sm font-medium leading-5 text-gray-500 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-l-md hover:text-gray-400 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-100 active:text-gray-500"
                                        aria-label="Previous"
                                    >
                                        <svg
                                            class="w-5 h-5"
                                            viewBox="0 0 20 20"
                                            fill="currentColor"
                                        >
                                            <path
                                                fill-rule="evenodd"
                                                d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                                                clip-rule="evenodd"
                                            />
                                        </svg>
                                    </button>

                                    <!-- v-if="!(page === 1 && nextBpis === null)" -->
                                    <span
                                        class="relative inline-flex items-center px-4 py-2 -ml-px text-sm font-medium leading-5 text-gray-700 bg-white border border-gray-300"
                                    >
                                        {{ page }}
                                    </span>

                                    <button
                                        :disabled="isNextPageDisabled"
                                        v-if="nextBpis !== null"
                                        @click="nexBpis"
                                        class="relative inline-flex items-center px-2 py-2 -ml-px text-sm font-medium leading-5 text-gray-500 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-r-md hover:text-gray-400 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-100 active:text-gray-500"
                                        aria-label="Next"
                                    >
                                        <svg
                                            class="w-5 h-5"
                                            viewBox="0 0 20 20"
                                            fill="currentColor"
                                        >
                                            <path
                                                fill-rule="evenodd"
                                                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                                clip-rule="evenodd"
                                            />
                                        </svg>
                                    </button>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </fragment>
</template>

<script>
import { db } from "@/services/firebase.service";
import NProgress from "nprogress";
import { cloneDeep } from "lodash";

export default {
    data() {
        return {
            currentBpis: [],
            nextBpis: [],
            prevBpis: [],
            open: false,
            sidebarOpen: false,
            prevDoc: null,
            currentDoc: null,
            pageBpis: new Map(),
            nextDocPointer: null,
            nextDoc: null,
            page: 1,
            cin: "",
            loading: false,
            isNextPageDisabled: false,
            isPrevPageDisabled: false
        };
    },
    async mounted() {
        NProgress.start();
        this.loading = true;

        try {
            const querySnapshot = await db
                .collection("bpis")
                .where("validation", "==", false)
                .limit(10)
                .get();
            this.nextDocPointer =
                querySnapshot.docs[querySnapshot.docs.length - 1];
            this.currentBpis = [];
            for await (const doc of querySnapshot.docs) {
                let curentBpisData = doc.data();
                let currentUserUID = curentBpisData.user.uid;

                let user = await db
                    .collection("users")
                    .doc(currentUserUID)
                    .get();

                this.currentBpis.push({
                    forms: { ...curentBpisData, user: user.data() },
                    id: doc.id
                });
            }
            this.pageBpis.set(`page${this.page}`, this.currentBpis);
        } catch (error) {
            console.log(error);
        } finally {
            try {
                const snapshot = await db
                    .collection("bpis")
                    .where("validation", "==", false)
                    .startAfter(this.nextDocPointer)
                    .limit(10)
                    .get();
                if (snapshot.size !== 0) {
                    this.nextDocPointer =
                        snapshot.docs[snapshot.docs.length - 1];

                    this.nextBpis = [];
                    for await (const doc of snapshot.docs) {
                        let nextBpisData = doc.data();
                        let nextUserUID = nextBpisData.user.uid;

                        let user = await db
                            .collection("users")
                            .doc(nextUserUID)
                            .get();

                        this.nextBpis.push({
                            forms: { ...nextBpisData, user: user.data() },
                            id: doc.id
                        });
                    }
                }
            } catch (error) {
                console.log(error);
            } finally {
                if (this.nextBpis !== null) NProgress.done();
                this.pageBpis.set(`page${this.page + 1}`, this.nextBpis);

                this.loading = false;
                this.$emit("fetching-data", false);
                NProgress.done();
            }
        }
    },
    methods: {
        selectBpiEdited(bpi) {
            this.$store.dispatch("user/AdminSelectBpi", bpi.id);
        },
        async nexBpis() {
            NProgress.start();

            this.isNextPageDisabled = true;

            this.prevBpis = cloneDeep(this.currentBpis);
            this.currentBpis = cloneDeep(this.nextBpis);

            if (this.pageBpis.has(`page${this.page + 2}`)) {
                this.nextBpis = this.pageBpis.get(`page${this.page + 2}`);
                this.isNextPageDisabled = false;
                this.page++;
                NProgress.done();
            } else {
                try {
                    const snapshot = await db
                        .collection("bpis")
                        .where("validation", "==", false)
                        .orderBy("ValidationDate", "desc")
                        .startAfter(this.nextDocPointer)
                        .limit(10)
                        .get();

                    if (snapshot.size !== 0) {
                        this.nextDocs = snapshot.docs;
                        this.nextDocPointer =
                            snapshot.docs[snapshot.docs.length - 1];

                        this.nextBpis = [];
                        for await (const doc of snapshot.docs) {
                            let nextBpisData = doc.data();
                            let nextUserUID = nextBpisData.user.uid;

                            let user = await db
                                .collection("users")
                                .doc(nextUserUID)
                                .get();
                            this.nextBpis.push({
                                forms: { ...nextBpisData, user: user.data() },
                                id: doc.id
                            });
                        }
                    } else {
                        this.nextBpis = null;
                    }
                } catch (error) {
                    console.log(error);
                } finally {
                    this.page++;
                    this.pageBpis.set(`page${this.page + 1}`, this.nextBpis);
                    this.isNextPageDisabled = false;
                    NProgress.done();
                }
            }
        },

        async prevBpi() {
            NProgress.start();

            this.page--;
            this.currentBpis = this.pageBpis.get(`page${this.page}`);

            this.nextBpis = this.pageBpis.get(`page${this.page + 1}`);
            NProgress.done();
        }
    },
    computed: {}
};
</script>

<style></style>
